import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardTitle,
  Input,
  Button,
  Table,
  Spinner,
  Row,
  Col,
  Label,
} from "reactstrap";
import {
  getHolidaysByYear,
  addHoliday,
  deleteHoliday,
} from "../../Api/ApiUrlConst";
import { useAuth } from "../../Context/AuthContext";

const HolidayManager: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const {  role } = useAuth();

  const [holidays, setHolidays] = useState<any[]>([]);
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [loading, setLoading] = useState(true);
   const Leave = role === 'Admin';

  useEffect(() => {
    loadHolidays();
  }, []);

  const loadHolidays = async () => {
    setLoading(true);
    try {
      const res = await getHolidaysByYear(currentYear);
      setHolidays(res.data);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async () => {
    if (!name || !date) {
      alert("Enter festival name and date");
      return;
    }

    await addHoliday({ name, date });
    setName("");
    setDate("");
    loadHolidays();
  };

  const handleDelete = async (id: number) => {
    await deleteHoliday(id);
    loadHolidays();
  };

      const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    weekday:"short"
  });

};

  return (
   <Card className="mt-4 shadow-lg border-0 rounded-4 overflow-hidden">
  
  {/* Header */}
  <div
    className="p-3 text-white"
    style={{
      background: "linear-gradient(45deg, #4e73df, #224abe)",
    }}
  >
    <h5 className="mb-0 fw-bold">Holidays</h5>
  </div>

  <CardBody className="p-4">

    {/* Input Section */}
    {Leave && (
      <div className="p-3 mb-4 rounded-3 shadow-sm bg-light border">
        <Row className="g-3 align-items-end">
          <Col md="5">
            <Input
              placeholder="Enter festival name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="rounded-3"
            />
          </Col>

          <Col md="4">
            <Input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="rounded-3"
            />
          </Col>

          <Col md="3">
            <Button
              style={{background: "linear-gradient(45deg, #4e73df, #224abe)"}}              
              onClick={handleAdd}
            >
              Add Holiday
            </Button>
          </Col>
        </Row>
      </div>
    )}

    {/* Holiday List */}
    {loading ? (
      <div className="text-center p-4">
        <Spinner color="primary" />
      </div>
    ) : (
      <div className="table-responsive">
        <Table hover responsive className="align-middle">
          <thead className="table-light">
            <tr>
              <th>Date</th>
              <th>Festival</th>
              {Leave && <th >Action</th>}
            </tr>
          </thead>

        <tbody>
  {holidays.length === 0 ? (
    <tr>
      <td colSpan={3} className="text-center text-muted">
        No holidays added
      </td>
    </tr>
  ) : (
    holidays.map((h) => {
      const isPast =
        new Date(h.date).setHours(0, 0, 0, 0) <
        new Date().setHours(0, 0, 0, 0);

      return (
        <tr
          key={h.id}
        
        >
        <td className="fw-semibold">
  {isPast ? (
    <span
      className="badge bg-danger"
      style={{ fontSize: "13px" }}
    >
      {formatDate(h.date)}
    </span>
  ) : (
    formatDate(h.date)
  )}
</td>



<td>
  {isPast ? (
    <span
      className="badge bg-danger"
      style={{ fontSize: "13px" }}
    >
      {h.name}
    </span>
  ) : (
    h.name
  )}
</td>


          {Leave && (
            <td>
              <Button
                size="sm"
                color="danger"
                outline
                onClick={() => handleDelete(h.id)}
              >
                Delete
              </Button>
            </td>
          )}
        </tr>
      );
    })
  )}
</tbody>



        </Table>
      </div>
    )}

  </CardBody>
</Card>

  );
};

export default HolidayManager;
